<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-col w-full mt-base">
          <vx-card class="mt-base">
            <div class="w-full flex flex-col">
              <div class="w-full relative">
                <div class="flex w-full  justify-between items-center">
                  <div class="text-xl flex-1 flex flex-col ">
                    <div class="font-semibold">Detail Template Surat</div>
                  </div>
                  <div class="flex">
                    <div
                      class="flex items-center cursor-pointer shadow px-4 py-2 rounded-lg mx-3"
                      @click="$refs.dialogUpdate.toggleActive(true)"
                    >
                      <feather-icon icon="EditIcon" class="mr-3"></feather-icon>
                      <div>Update Template</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <h6>Nama Template Surat:</h6>
              <p>{{templateSurat.nama}}</p>
            </div>
            <div class="mt-5">
              <h6>Keterangan :</h6>
              <p>{{templateSurat.kategori_surat.nama}}</p>
            </div>
            <div class="mt-5">
              <h6>Keterangan :</h6>
              <p>{{templateSurat.keterangan}}</p>
            </div>
            <div class="mt-5">
              <h6>File Template :</h6> <br>
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-edit"
                class="mb-4 self-end"
                size="small"
                @click="downloadFile(templateSurat.dokumen[0].file_url)"
                > Lihat Template Surat
              </vs-button>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <br>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/4">
        <vs-button
            @click="$router.push({name: 'template-surat'})"
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-arrow-left"
            class="mb-4 self-end"
            size="small"
          > Kembali
        </vs-button>
      </div>
    </div>
    <DialogUpdate
      ref="dialogUpdate"
      :templateSurat="templateSurat"
      @submitCallback="refreshTemplateSuratQuery"
    />
</div>
</template>

<script>
import { FIND } from '@/query/template-surat';
import DialogUpdate from "./DialogUpdate";
import { digofHttp as axios } from "@/axios";

export default {
  components: {
    DialogUpdate,
  },
  data() {
    return {
      templateSurat : {
        kategori_surat : {
          nama : ''
        }
      },
    };
  },
  apollo : {
    templateSurat: {
      query: FIND,
      update(data) {
        return data.templateSurat;
      },
      variables() {
        return {
          where: {column : 'UUID', value: this.$route.params.uuid}
        };
      },
      fetchPolicy: "cache-and-network",
    },
  },
  methods : {
    refreshTemplateSuratQuery(){
      this.$apollo.queries.templateSurat.refetch();
    },
    downloadFile(url) {
      window.open(url);
    },
    getFileTemplate(){
      let uuid = this.templateSurat.dokumen[0].uuid;
      let filename = this.templateSurat.dokumen[0].nama;
      axios({
        url: `template-surat/get-template-file/${uuid}`,
        method: "get",
        responseType : 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch(e => {
        console.error(e);
        this.$vs.notify({
          title: "Gagal",
          text: "Terjadi kesalahan, silahkan hubungi tim IT!",
          color: "danger",
          position: "top-right"
        });
      });
    },
  },
};
</script>